import FormFieldSet from './FormFieldSet'
import { arrayOfObjectsSummarizer } from '@/utility/utility_functions'

export default class FormDescriptor {
  constructor (id, fieldSets) {
    this.id = id
    this.fieldSets = fieldSets
  }

  static asFormDescriptors (json) {
    return json.map(formDescriptor => {
      return FormDescriptor.asFormDescriptor(formDescriptor)
    })
  }

  static asFormDescriptor (json) {
    return new FormDescriptor(
      json.id,
      json.field_sets ? FormFieldSet.asFormFieldSets(json.field_sets) : []
    )
  }

  static checkFormDescriptorsDependencies (formDescriptors, formDatas) {
    formDescriptors.forEach(formDescriptor => {
      let formData = formDatas.find(formData => formDescriptor.id === formData.formDescriptorId)
      formDescriptor.checkFormDescriptorDependencies(formData)
    })
  }

  // TODO: used only temporarily to extend certain fieldSets depending on the data being returned
  static initiateTemplateFieldSets (formDescriptorJson, formDataJson) {
    let formDataGroupsSummary = arrayOfObjectsSummarizer(formDataJson, 'data_group')
    let fieldSet = formDescriptorJson.field_sets.find(fieldSet => {
      return fieldSet.type && fieldSet.type.toUpperCase() === 'FORMSET'
    })
    if (fieldSet) {
      for (let group of formDataGroupsSummary) {
        if (group.name === fieldSet.form_fields[0].data_group) {
          for (let i = 0; i < group.count - 1; i++) {
            formDescriptorJson.field_sets.push(JSON.parse(JSON.stringify(fieldSet)))
          }
        }
      }
    }
  }

  checkFormDescriptorDependencies (formData) {
    if (!this.fieldSets || this.fieldSets.length < 1) {
      return
    }

    this.fieldSets.forEach(form => {
      form.checkFieldSetDependencies(formData)
    })
  }

  sortFieldSets () {
    this.fieldSets.sort(function (a, b) {
      return a.layout.position - b.layout.position
    })
  }

  getFormData (formDatas) {
    return formDatas.find(formData => this.id === formData.formDescriptorId)
  }
}
